
export const constants = {
    isDev: "ontouchstart" in window ?
        (() => {
            $("html").removeClass("no-dev");
            return true;
        })() :
        false,
    $body: $("body"),
    $window: $(window),
    $document: $(document),
};


// WEBPACK FOOTER //
// ./assets/js/modules/module.js